/* istanbul ignore file */
import React from 'react';
import { GlobalPermissionsLoader } from 'framework/authorization';
import useDavinciAuthorizationService from 'infrastructure/security/authorization/davinciAuthorizationService';
import { useAuthenticationProvider } from 'infrastructure/security/authentication/AuthenticationProvider';

const GlobalPermissionsProvider = ({ children }: { children: React.ReactNode }) => {
  const { getGlobalPermissions } = useDavinciAuthorizationService();
  const { isAuthenticated } = useAuthenticationProvider();

  return (
    <GlobalPermissionsLoader getGlobalPermissions={getGlobalPermissions} isUserAuthenticated={isAuthenticated}>
      {children}
    </GlobalPermissionsLoader>
  );
};

export default GlobalPermissionsProvider;
